module.exports = __webpack_public_path__ + "img/check-list 1.f1c40fca.svg";